import {I18n} from '@aws-amplify/core';
import {Image, Stack} from "@mantine/core";
import {
    PlatformPropertyCard,
    PlatformPropertyCardEntryInput
} from "@flexinet/ui-components";
import {Product,} from '../types';
import {StatusBadge} from "./StatusBadge.tsx";
import {FreeTrialBadge} from "./FreeTrialBadge.tsx";


// Typed, not cast (§13): a cast switches off the excess-property check that catches a
// misspelt key. Empty optional fields render the dash rather than a blank row.
export const InformationPropertyCard = ({record}: { record: Product }) => {

    const properties: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Name'),
            value: record.name,
            span: 12,
        }, {
            label: I18n.get('Status'),
            value: <StatusBadge status={record.status}/>,
            span: 12,
        }, {
            label: I18n.get('Free Trial Available'),
            value: <FreeTrialBadge record={record}/>,
            span: 12,
        }
    ];

    const properties2: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Short Description'),
            value: record.shortDescription,
            emptyAs: 'dash',
            span: 12,
        }, {
            label: I18n.get('Long Description'),
            value: record.longDescription,
            emptyAs: 'dash',
            span: 12,
        }, {
            label: I18n.get('Product Image'),
            value: record.productImage,
            emptyAs: 'dash',
            decorator: (value: string) => <Image src={value} alt={record.name} maw={150}/>,
            span: 12,
        }
    ];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
